<script>
  function formatLabels(value) {
    let label
    if (value < 10000000) {
      label = format('.1s')(value)
    } else {
      label = format('.2s')(value)
    }
    if (value < 3500000) {
      return label
    } else {
      return label.replace('M', '')
    }
  }

  import { onMount } from 'svelte'
  let promise = false
  let margin = {
    top: 20,
    right: 20,
    bottom: 20,
    left: 20,
  }
  let formatDate = timeFormat('%e %b')
  export let data
  export let dataKZN
  export let dataGP
  export let dataPhoenix

  data.forEach((d) => {
    d.date = timeParse('%Y-%m-%d')(d.date)
  })
  dataKZN.forEach((d) => {
    d.date = timeParse('%Y-%m-%d')(d.date)
  })
  dataGP.forEach((d) => {
    d.date = timeParse('%Y-%m-%d')(d.date)
  })
  dataPhoenix.forEach((d) => {
    d.date = timeParse('%Y-%m-%d')(d.date)
  })
  import { scaleLinear, scaleTime } from 'd3-scale'
  import { extent, max } from 'd3-array'
  import { timeParse, timeFormat } from 'd3-time-format'
  import { line, area } from 'd3-shape'
  import { curveLinear } from 'd3-shape'
  import { format } from 'd3-format'
  let scaleVal = 0.3

  let width = 300
  $: height = width * scaleVal

  $: if (width) {
    console.log(width)
  }
  $: if (width < 900) {
    scaleVal = 0.7
  } else {
    scaleVal = 0.3
  }

  $: xScale = scaleTime()
    .domain(extent(data, (d) => d.date))
    .range([margin.left, width - margin.right])

  $: yScale = scaleLinear()
    .domain([0, max(dataPhoenix, (d) => +d.retweets)])
    .range([height - margin.bottom, margin.top])

  $: line_gen = line()
    .curve(curveLinear)
    .x((d) => xScale(d.date))
    .y((d) => yScale(+d.retweets))

  $: line_gen2 = line()
    .x((d) => xScale(d.date))
    .y((d) => yScale(+d.tweets))

  $: area_gen = area()
    .x((d) => xScale(d.date))
    .y0(height - margin.bottom - 0)
    .y1((d) => yScale(d.retweets))

  $: xTicks = xScale.ticks(8)
  $: yTicks = yScale.ticks(5)

  onMount(() => {
    setTimeout(() => {
      promise = true
    }, 1000)
  })
</script>

<div class="line-chart" bind:clientWidth={width} style="height: {height}px;">
  {#if promise}
    <svg {width} {height}>
      <rect
        x={xScale(xTicks[1])}
        y={margin.top}
        width={xScale(xTicks[2]) - xScale(xTicks[1])}
        height={height - margin.top - margin.bottom}
        class="bg-rect"
      />
      <rect
        x={xScale(xTicks[3])}
        y={margin.top}
        width={xScale(xTicks[4]) - xScale(xTicks[3])}
        height={height - margin.top - margin.bottom}
        class="bg-rect"
      />

      <rect
        x={xScale(xTicks[5])}
        y={margin.top}
        width={xScale(xTicks[6]) - xScale(xTicks[5])}
        height={height - margin.top - margin.bottom}
        class="bg-rect"
      />
      <rect
        x={xScale(xTicks[7])}
        y={margin.top}
        width={xScale(xTicks[7]) - xScale(xTicks[6])}
        height={height - margin.top - margin.bottom}
        class="bg-rect"
      />

      {#each yTicks as tick}
        <!-- svelte-ignore component-name-lowercase -->
        <line
          x1={margin.left}
          x2={width}
          y1={yScale(tick)}
          y2={yScale(tick)}
          class="y-grid"
        />
        <text x={margin.left - 5} y={yScale(tick) + 3} class="y-label">
          {formatLabels(tick)}</text
        >
      {/each}
      {#each xTicks as tick}
        <!-- svelte-ignore component-name-lowercase -->
        <line
          x1={xScale(tick)}
          x2={xScale(tick)}
          y1={margin.top}
          y2={height - margin.bottom / 2}
          class="x-tick"
        />
        <text class="x-date" x={xScale(tick)} y={height}
          >{formatDate(tick)}</text
        >
      {/each}

      <path class="chart-area-two" d={area_gen(dataKZN)} />
      <path class="chart-area-one" d={area_gen(data)} />
      <path class="chart-area-four" d={area_gen(dataPhoenix)} />

      <path class="chart-line chart-line-two" d={line_gen(dataKZN)} />
      <path class="chart-line chart-line-two dashed" d={line_gen2(dataKZN)} />
      <path class="chart-line chart-line-one" d={line_gen(data)} />
      <path class="chart-line chart-line-one dashed" d={line_gen2(data)} />
      <path class="chart-area-three" d={area_gen(dataGP)} />
      <path class="chart-line chart-line-three" d={line_gen(dataGP)} />
      <path class="chart-line chart-line-three dashed" d={line_gen2(dataGP)} />
      <path class="chart-line chart-line-four" d={line_gen(dataPhoenix)} />
      <path
        class="chart-line chart-line-four dashed"
        d={line_gen2(dataPhoenix)}
      />

      <!-- <path class="chart-line chart-line-two" d={line_gen2(data)} /> -->
      <!-- svelte-ignore component-name-lowercase -->
      <line
        x1={margin.left}
        x2={width - margin.right}
        y1={height - margin.bottom}
        y2={height - margin.bottom}
        class="x-line"
      />
      <!-- <text
        x={xScale(xTicks[1])}
        y={yScale(data[1].tweets) - 10}
        class="line-annotation-tweets">Tweets</text
      > -->

      <text
        x={xScale(xTicks[1])}
        y={yScale(data[1].retweets) - 10}
        class="line-annotation-retweets">#FreeJacobZuma</text
      >
      <text
        x={xScale(xTicks[2])}
        y={yScale(dataKZN[2].retweets) - 10}
        class="line-annotation-tweets">#KZNShutdown</text
      >
      <text
        x={xScale(xTicks[3]) + 30}
        y={yScale(dataGP[3].retweets) + 50}
        class="line-annotation-gp">#GautengShutdown</text
      >

      <text
        x={xScale(xTicks[7]) - 10}
        y={yScale(dataPhoenix[7].retweets) + 20}
        class="line-annotation-ph">#PhoenixMassacre</text
      >

      <text
        x={xScale(xTicks[2])}
        y={yScale(dataKZN[3].tweets) - 15}
        class="line-annotation-legend">Tweets</text
      >

      <text
        x={xScale(xTicks[1])}
        y={yScale(dataKZN[1].retweets) - 15}
        class="line-annotation-legend">Retweets</text
      >
    </svg>
  {/if}
</div>

<style>
  :root {
    --gridGray: rgb(117, 117, 117);
  }
  svg {
    overflow: visible;
  }
  .line-chart {
    max-width: 100%;
    color: #fff;
    font-size: 0.9rem;
    margin-bottom: 50px;
  }
  .line-chart text {
    fill: #fff;
  }
  path {
    stroke-width: 3px;
    stroke: hotpink;
    fill: none;
  }
  path.chart-line-two {
    /* stroke-width: 2px; */

    stroke: rgb(255, 251, 27);
    /* stroke-dasharray: 3, 3; */
  }
  path.chart-line-three {
    stroke: rgb(16, 211, 218);
    /* stroke-dasharray: 3, 3; */
  }
  path.chart-line-four {
    /* stroke-width: 2px; */

    stroke: rgb(26, 173, 6);
    /* stroke-dasharray: 3, 3; */
  }
  .x-line {
    stroke: var(--gridGray);
  }
  .chart-area-one {
    fill: #431b2eb0;
    stroke: none;
  }

  .chart-area-two {
    fill: rgba(255, 252, 95, 0.281);
    stroke: none;
  }
  .chart-area-three {
    fill: rgba(16, 211, 218, 0.356);
    stroke: none;
  }
  .chart-area-four {
    fill: rgba(32, 204, 9, 0.342);
    stroke: none;
  }
  .x-tick {
    stroke: var(--gridGray);
    stroke-width: 1px;
    shape-rendering: crispEdges;
    stroke-dasharray: 3, 3;
  }
  .x-date {
    font-size: 0.7rem;
    text-anchor: middle;
    text-transform: uppercase;
  }
  text.x-date {
    fill: rgb(131, 131, 131);
    stroke: none;
    font-weight: 700;
    shape-rendering: crispEdges;
  }
  .y-grid {
    stroke: var(--gridGray);
    stroke-width: 1px;
    shape-rendering: crispEdges;
    stroke-dasharray: 3, 3;
  }
  .y-label {
    text-anchor: end;
    font-size: 0.7rem;
  }
  text.y-label {
    fill: rgb(131, 131, 131);
  }
  .bg-rect {
    fill: rgba(255, 255, 255, 0.041);
  }
  text.line-annotation-tweets,
  text.line-annotation-retweets,
  text.line-annotation-gp,
  text.line-annotation-legend,
  text.line-annotation-ph {
    fill: rgb(255, 251, 27);
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: 700;
    paint-order: stroke;
    stroke-width: 5px;
    stroke: #1d1d1d;
  }
  text.line-annotation-retweets {
    fill: hotpink;
  }
  text.line-annotation-gp {
    fill: rgb(16, 211, 218);
  }
  text.line-annotation-ph {
    fill: rgb(26, 173, 6);
    text-anchor: end;
  }
  text.line-annotation-legend {
    text-anchor: end;
    font-weight: 400;
    fill: #fff;
  }
  .dashed {
    stroke-dasharray: 3, 3;
    stroke-width: 2;
  }
</style>
